module.exports = __webpack_public_path__ + "static/media/refrigDead.19c0c3a7.png";